module.exports = __webpack_public_path__ + "img/step-1-img.24d8a798.svg";